import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	IOrganizationAttendeesStatistics,
	IOrganizationAttendeesListRequest,
	IOrganizationAttendeesListResponse,
	IOrganizationAttendee,
} from '../../utils/types';
//services
import {OrganizationAttendeesService} from '@/utils/services/organization-attendee.service';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const getAttendeesList = createAsyncThunk(
	ACTION_TYPE.ATTENDEES_LIST,
	async (reqBody: IOrganizationAttendeesListRequest, {rejectWithValue}) => {
		try {
			const attendeesResponse: AxiosResponse<IOrganizationAttendeesListResponse> =
				await OrganizationAttendeesService.getAttendeesList(reqBody);

			return attendeesResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getAttendeesStatistics = createAsyncThunk(
	ACTION_TYPE.ATTENDEE_STATISTICS,
	async (eventId: number, {rejectWithValue}) => {
		try {
			const attendeesResponse: AxiosResponse<IOrganizationAttendeesStatistics> =
				await OrganizationAttendeesService.getAttendeesStatistics(eventId);
			return attendeesResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getAttendee = createAsyncThunk(ACTION_TYPE.ATTENDEE, async (attendeeId: number, {rejectWithValue}) => {
	try {
		const attendeesResponse: AxiosResponse<IOrganizationAttendee> = await OrganizationAttendeesService.getAttendee(
			attendeeId
		);
		return attendeesResponse.data;
	} catch (error) {
		return rejectWithValue(getErrorResponse(error));
	}
});
